<template>
  <div class="wrapper info">
    <div class="header">个人信息</div>
    <div class="infobox">
      <div class="coll-body">
        <div class="coll-body-header">
          <div class="title">姓名：{{ info.Surname }}</div>
          <div @click="editColl(info)" class="txt-icon">
            <van-icon name="edit" color="#009E38" size="20" />
          </div>
        </div>
        <div class="coll-body-content">
          <div class="txt">
            手机号：<span>{{ info.Mobile }}</span>
          </div>
          <div class="txt">邮箱：{{ info.Email }}<span></span></div>
          <div class="txt">
            公司：<span>{{ info.CompanyName }}</span>
          </div>
          <div class="txt">
            证件号：<span>{{ info.CardNo }}</span>
          </div>
        </div>
      </div>
      <div class="per-btn">
        <van-button
          round
          block
          type="primary"
          color="#009E38"
          native-type="button"
          @click="gouser"
          >返回个人中心</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/user.js";
import { button } from "vant";
export default {
  data() {
    return {
      info: [],
    };
  },
  components: {
    [button.name]: button,
  },
  created() {
    this.getInfolist(this.$route.query.pkey);
  },

  methods: {
    editColl(item) {
      console.log(item);
      if (item && item.FullCardNumber) {
        var params = {
          ckey: item.FullCardNumber,
        };
        this.$router.push({
          path: "reg/personal",
          query: {
            redirect: "user",
          },
        });
      }
    },
    gouser() {
      this.$router.push({
        path: "user",
      });
    },
    getInfolist(ckey) {
      let _this = this;
      getInfo({ ckey: ckey }).then((res) => {
        if (res.state == "success") {
          _this.info = res.data;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.info {
  background: #fff;
}
.infobox {
  padding: 15px;
  .coll-body {
    margin-top: 10px;
    .coll-body-header {
      display: flex;
      font-size: 16px;
      justify-content: space-between;
      .title {
        font-weight: bold;
      }
    }
    .coll-body-content {
      margin-top: 20px;
      font-size: 14px;
      line-height: 21px;
      color: #999;
    }
  }
}
</style>